import React from 'react';
import './ConnectorShell.css';
import HelpTourButton from '../guidedTour/HelpTourButton';

interface ConnectorSectionShellProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  icon?: string;
  actions?: React.ReactNode;
  onHelp?: () => void;
  children: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  hideHero?: boolean;
}

const ConnectorSectionShell: React.FC<ConnectorSectionShellProps> = ({
  eyebrow,
  title,
  subtitle,
  icon,
  actions,
  onHelp,
  children,
  className = '',
  bodyClassName = '',
  hideHero = false,
}) => {
  return (
    <section className={`connector-shell-page connector-section ${className}`.trim()}>
      {!hideHero && (
        <header className="connector-section-hero">
          <div className="connector-section-hero__content">
            {eyebrow && (
              <div className="connector-section-hero__badge">
                {icon ? <i className={`fas ${icon}`} aria-hidden="true" /> : null}
                {eyebrow}
              </div>
            )}
            <h2 className="connector-section-hero__title">{title}</h2>
            {subtitle ? <p className="connector-section-hero__subtitle">{subtitle}</p> : null}
          </div>
          {(actions || onHelp) && (
            <div className="connector-section-hero__actions">
              {actions}
              {onHelp ? <HelpTourButton onClick={onHelp} /> : null}
            </div>
          )}
        </header>
      )}

      <div className={`connector-section-body ${bodyClassName}`.trim()}>{children}</div>
    </section>
  );
};

export default ConnectorSectionShell;
